import script from "./Blog.vue?vue&type=script&setup=true&lang=js"
export * from "./Blog.vue?vue&type=script&setup=true&lang=js"

import "./Blog.vue?vue&type=style&index=0&id=6b9bb1e6&scoped=true&lang=css"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b9bb1e6"]])

export default __exports__